import React from 'react';
import { Link } from 'gatsby';
import { connectHits } from 'react-instantsearch-dom';
import PressIcon from '../../images/search/press.svg';
import RowSet from '../primitives/grid/row-set';
import flattenSnippet from '../../utils/flatten-snippet';
import NoResults from '../search/no-results';

interface SearchTileProps {
    title: string
    bodyText: string
    link: string
    icon?: React.ReactNode
}

const SearchTilePress = ({ title, bodyText, link, icon }: SearchTileProps): JSX.Element => {
    const url = new URL(link);
    return (
        <Link
            css={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
            }}
            to={url.pathname}
        >
            <div css={{
                marginTop: '6px',
                width: '32px',
                height: '32px',
                marginRight: '12px',
                '@media (max-width: 767px)': {
                    width: '24px',
                    height: '24px',
                    marginRight: '6px',
                },
            }}
            >
                {icon || <PressIcon css={{ maxHeight: '100%', maxWidth: '100%', height: '100%', fill: 'rgb(230, 0, 5)' }} />}
            </div>
            <div css={{ width: '100%' }}>
                <div className="h5">{title}</div>
                <div
                    css={{
                        '& ais-highlight-0000000000': {
                            backgroundColor: '#b4c3d7',
                            borderRadius: '4px',
                        },
                    }}
                    className="p2"
                    dangerouslySetInnerHTML={{ __html: bodyText }}
                />
            </div>
        </Link>
    );
};

export default SearchTilePress;

export const SearchTilePressHits = connectHits(({ hits }: any) => (
    <RowSet breakpoints={{ dt: { between: 36 } }}>
        {(hits && hits.length > 0) ? hits.map((hit: any, index: number) => {
            const flattedSnipped = flattenSnippet(hit._snippetResult);
            return (
                <SearchTilePress
                    key={index}
                    title={hit?.post_title}
                    bodyText={flattedSnipped}
                    link={hit?.permalink}
                />
            );
        }) : (
            <NoResults />
        )}
    </RowSet>
));
